const UserRole = {
  ADMIN: 'admin',
  CANDIDATE: 'candidate',
  EMPLOYER: 'employer',
  RECRUITER: 'recruiter',
};
export default UserRole;
